import type { ApolloClient } from '@apollo/client';
import { type ClientOptions, createClient } from '@seek/ca-graphql-client';
import { browserHttpLink } from '@seek/ca-graphql-client/browser';

import { mutationMetricsLink, onErrorLink } from './links/on-error-link';
import { removeTypeNameLink } from './links/remove-typename-link';
import { visitorIdLink } from './links/visitor-id-link';

export { setVisitorId } from './links/visitor-id-link';

export let apolloClient = null as unknown as ApolloClient;

const getLocalAuthToken = () =>
  typeof window !== 'undefined' ? window.CONFIG.AUTH_OVERRIDE : null;

const localDevBrowserLink = ({ headers, ...others }: any) =>
  browserHttpLink({
    ...others,
    headers: {
      ...headers,
      authorization: `Bearer ${getLocalAuthToken()}`,
    },
  } as any);

export const createApollo = (
  brand: ClientOptions['brand'],
  country: ClientOptions['country'],
  env: string,
  version: string,
  graphqlEndpoint: string | undefined,
) => {
  const isLocalEnv = env === 'local';

  const getLocalGraphEndpoint = () => graphqlEndpoint || '/graphql';

  const temp = createClient({
    brand,
    country,
    headers: {
      Accept: 'application/features.seek.all+json',
      'x-seek-web-version': version,
    },
    appName: 'ca-jobapply-frontend',
    httpLink: isLocalEnv ? localDevBrowserLink : browserHttpLink,
    links: [
      visitorIdLink,
      removeTypeNameLink,
      onErrorLink,
      mutationMetricsLink,
    ],
    graphqlEndpointOverride: isLocalEnv ? getLocalGraphEndpoint() : undefined,
    authOptions: {
      useAuth: true,
      forceStrategy: 'AUTH0',
    },
    batchRequests: !isLocalEnv,
    batchRequestOptions: {
      batchMax: 10,
    },
    cacheOptions: {
      typePolicies: {
        QuestionOption: {
          keyFields: ['id', 'text'],
        },
        FileMetadata: {
          keyFields: ['uri'],
        },
        JobApplicationProcess: {
          keyFields: [], // singleton
        },
        Skill: {
          keyFields: ['keyword', ['ontologyId', 'text']],
        },
      },
    },
  });
  // TODO: should not allow direct access by import
  // upload resume still ref to this
  apolloClient = temp;
  return apolloClient;
};
